<template>
  <div
    class="relative flex items-center w-full h-full min-w-[160px] min-h-[70px] rounded-xl"
    :class="[
      {
        'bg-[#d0d8ff]': metric.input_type == 'Number',
        'bg-[#d0d8ff]': metric.input_type == 'EmployeeCount',
        'bg-[#9747FF80]': metric.input_type == 'Decimal',
        'bg-[#0D729980]': metric.input_type == 'Percent',
        'bg-[#FFF1E4]': metric.input_type == 'Currency',
        'bg-[#D1970080]': metric.input_type == 'StarRating',
        'bg-[#DB00FF80]': metric.input_type == 'BarRating',
        'bg-[#F1F8FF]': metric.input_type == 'Linkedin',
        'bg-[#F4EBFF]': metric.input_type == 'Website',
        'bg-[#e4fff4]': metric.input_type == 'Founded',
        'bg-[#FFF8E7]': metric.input_type == 'Adress',
        'bg-[#FFE3E5]': metric.input_type == 'Industry',
        'cursor-pointer': (metric.input_type == 'Linkedin' || metric.input_type == 'Website') && metric?.link
      }
    ]"
    @click="(metric.input_type == 'Linkedin' || metric.input_type == 'Website') && metric?.link ? openLink(metric.link) : null">
    <div class="flex items-center justify-center bg-white rounded-full mx-2 w-10 h-10">
      <NumbersIcon v-if="metric.input_type == 'Number'" color="#D0D8FF" class="w-[32px] h-[32px]" />
      <DecimalIcon v-else-if="metric.input_type == 'Decimal'" class="w-[32px] h-[32px]" />
      <PercentIcon v-else-if="metric.input_type == 'Percent'" class="w-[32px] h-[32px]" />
      <DollarSign v-else-if="metric.input_type == 'Currency'" color="#FF7A00" class="w-5 h-5" />
      <StarRatingIcon v-else-if="metric.input_type == 'StarRating'" class="w-[32px] h-[32px]" />
      <BarRatingIcon v-else-if="metric.input_type == 'BarRating'" class="w-[32px] h-[32px]" />
      <Linkedin v-else-if="metric.input_type == 'Linkedin'" class="w-5 h-5" color="#0A66C2" />
      <Link v-else-if="metric.input_type == 'Website'" class="w-6 h-6" />
      <FoundedIcon v-else-if="metric.input_type == 'Founded'" class="w-5 h-5" />
      <MapPin v-else-if="metric.input_type == 'Adress'" class="w-6 h-6" color="#FFF8E7" />
      <Factory v-else-if="metric.input_type == 'Industry'" class="w-6 h-6" color="#FF636C" />
      <UsersRound v-else-if="metric.input_type == 'EmployeeCount'" class="w-5 h-5" color="#1037FF" />
    </div>
    <div class="flex flex-col">
      <span class="font-bold text-[#46545C]">{{ metric.label }}</span>
      <span class="text-sm text-[#899399]">{{ metric.description }}</span>
    </div>
  </div>
</template>

<script>
import NumbersIcon from "../icons/NumbersIcon.vue"
import DecimalIcon from "../icons/DecimalIcon.vue"
import PercentIcon from "../icons/PercentIcon.vue"
import StarRatingIcon from "../icons/StarRatingIcon.vue"
import BarRatingIcon from "../icons/BarRatingIcon.vue"
import { DollarSign, Linkedin, Factory, UsersRound, MapPin, Link } from "lucide-vue-next"
import FoundedIcon from "../icons/FoundedIcon.vue"

export default {
  components: {
    NumbersIcon,
    DecimalIcon,
    PercentIcon,
    DollarSign,
    StarRatingIcon,
    BarRatingIcon,
    Linkedin,
    Link,
    FoundedIcon,
    MapPin,
    Factory,
    UsersRound
  },
  props: {
    metric: {
      type: Object,
      required: true
    }
  },
  emits: ["dblclick", "update:previewSelections"],
  data() {
    return {}
  },
  computed: {},
  watch: {},

  created() {},
  activated() {},
  deactivated() {},
  unmounted() {},
  methods: {
    openLink(link) {
      let url = link
      if (!url.startsWith("http://") && !url.startsWith("https://")) {
        url = "http://www." + url
      }
      window.open(url, "_blank")
    }
  }
}
</script>
